import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { FoodType } from "../food-types/food-types.entitiy";
import { Grades } from "../grades/grades.entity";
import { Item } from "../items/item.entity";
import { Product } from "../products/product.entity";
import { ValueAdditionOneType } from "../value-addition1-types/value-addition-one.entity";
import { ValueAdditionTwoType } from "../value-addition2-types/value-addition-two.entity";
import { ValueAdditionThreeType } from "../value-addition3-types/value-addition-three.entity";
import { ValueAdditionFourType } from "../value-addition4-types/value-addition-four.entity";
import { ValueAdditionFiveType } from "../value-addition5-types/value-addition-five.entity";

@Entity('sku_codes')
export class SkuCodes {

  @PrimaryGeneratedColumn("increment", { name: 'sku_code_id' })
  skuCodeId: number;

  @Column("int", {
    nullable: false,
    name: "product_id"
  })
  productId: number;
  @Column("int", {
    nullable: false,
    name: "min_count"
  })
  minCount: number;
  @Column("int", {
    nullable: false,
    name: "max_count"
  })
  maxCount: number;
  @Column("int", {
    nullable: false,
    name: "required_count"
  })
  requiredCount: number;
  @Column("int", {
    nullable: false,
    name: "grade_id"
  })
  gradeId: number;
  // @Column("int",{
  //   nullable:false,
  //   name:"min_grade_id"
  //   })
  // minGradeId:number;
  // @Column("int",{
  //   nullable:false,
  //   name:"max_grade_id"
  //   })
  // maxGradeId:number;
  @Column("int", {
    nullable: false,
    name: "min_glaze"
  })
  minglaze: number;
  @Column("int", {
    nullable: false,
    name: "max_glaze"
  })
  maxglaze: number;
  @Column("varchar", {
    nullable: false,
    length: 20,
    name: "soaking_style"
  })
  soakingStyle: string;
  @Column("varchar", {
    nullable: false,
    length: 20,
    name: "soaking_time"
  })
  soakingTime: string;
  @Column("int", {
    nullable: false,
    name: "food_type_id"
  })
  foodTypeId: number;
  @Column("int", {
    nullable: false,
    name: "value_addition_one_id"
  })
  valueAdditionOneId: number;
  @Column("int", {
    nullable: false,
    name: "value_addition_two_id"
  })
  valueAdditionTwoId: number;
  @Column("int", {
    nullable: false,
    name: "value_addition_three_id"
  })
  valueAdditionThreeId: number;
  @Column("int", {
    nullable: false,
    name: "value_addition_four_id"
  })
  valueAdditionFourId: number;
  @Column("int", {
    nullable: false,
    name: "value_addition_five_id"
  })
  valueAdditionFiveId: number;
  // @Column("varchar",{
  //     nullable:false,
  //     length:30,
  //     name:"sku_code"
  //     })
  //     skuCode:string;
  @Column("varchar", {
    nullable: false,
    length: 50,
    name: "variant_code"
  })
  variantCode: string;

  @Column("decimal", {
    nullable: false,
    name: "loss_or_gain_percentage",
    precision: 5, scale: 2
  })
  lossOrGainPercentage: number;

  @Column("int", {
    nullable: false,
    name: "unit_price"
  })
  unitPrice: number;
  //need to remove this column after all changes     
  @Column("decimal", {
    nullable: false,
    name: "only_salt",
    precision: 5, scale: 2
  })
  onlySalt: number;
  //need to remove this column after all changes 
  @Column("decimal", {
    nullable: false,
    name: "sttp_salt",
    precision: 5, scale: 2
  })
  sttpSalt: number;
  //need to remove this column after all changes 
  @Column("decimal", {
    nullable: false,
    name: "np_salt",
    precision: 5, scale: 2
  })
  npSalt: number;
  //need to remove this column after all changes 
  @Column("decimal", {
    nullable: false,
    name: "cp_salt",
    precision: 5, scale: 2
  })
  cpSalt: number;
  @Column("decimal", {
    nullable: false,
    name: "val_addition_loss_percentage",
    precision: 5, scale: 2
  })
  valueAdditionLossPercentage: number;
  @Column("decimal", {
    nullable: false,
    name: "soaking_gain_percentage",
    precision: 5, scale: 2
  })
  soakingGainPercentage: number;
  @Column("decimal", {
    nullable: false,
    name: "cooking_loss_percentage",
    precision: 5, scale: 2
  })
  cookingLossPercentage: number;

  @Column("varchar", {
    nullable: false,
    name: "short_code",
  })
  shortCode: string;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user",
    length: 50
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length: 50
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @ManyToOne(type => Product, product => product.productId, { nullable: false, })
  @JoinColumn({ name: "product_id" })
  productInfo: Product;

  @ManyToOne(type => Grades, grade => grade.gradeId, { nullable: false, })
  @JoinColumn({ name: "grade_id" })
  gradeInfo: Grades;

  @ManyToOne(type => FoodType, foodType => foodType.foodTypeId, { nullable: false, })
  @JoinColumn({ name: "food_type_id" })
  foodTypeInfo: FoodType;

  @ManyToOne(type => ValueAdditionOneType, valueAdditionOneType => valueAdditionOneType.valueAdditionOneId, { nullable: false, })
  @JoinColumn({ name: "value_addition_one_id" })
  valueAdditionOneTypeInfo: ValueAdditionOneType;
  @ManyToOne(type => ValueAdditionTwoType, valueAdditionTwoType => valueAdditionTwoType.valueAdditionTwoId, { nullable: false, })
  @JoinColumn({ name: "value_addition_two_id" })
  valueAdditionTwoTypeInfo: ValueAdditionTwoType;
  @ManyToOne(type => ValueAdditionThreeType, valueAdditionThreeType => valueAdditionThreeType.valueAdditionThreeId, { nullable: false, })
  @JoinColumn({ name: "value_addition_three_id" })
  valueAdditionThreeTypeInfo: ValueAdditionThreeType;
  @ManyToOne(type => ValueAdditionFourType, valueAdditionFourType => valueAdditionFourType.valueAdditionFourTypeInfo, { nullable: false, })
  @JoinColumn({ name: "value_addition_four_id" })
  valueAdditionFourTypeInfo: ValueAdditionFourType;
  @ManyToOne(type => ValueAdditionFiveType, valueAdditionFiveType => valueAdditionFiveType.valueAdditionFiveTypeInfo, { nullable: false, })
  @JoinColumn({ name: "value_addition_five_id" })
  valueAdditionFiveTypeInfo: ValueAdditionFiveType;
  @OneToMany(type => Item, item => item.skuInfo)
  itemInfo: Item[];
}
